//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CardPropertyIcon',
  props: {
    property: {
      type: Object,
      default () {
        return {}
      }
    },
    icon: {
      type: String,
      default: null
    },
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconLocal: function () {
      return this.icon || this.property._icon
    }
  }
}
